import React, { useState } from "react";
import { getDomain, DEFAULT_ENV } from "../../constants";
import EnvironmentSelector from "../options/environment_selector";
import InvisibleRequest from "../options/invisible_request";
import EmbedContainer from "../embed/container";
const CustomDemo = () => {
  const [token, setToken] = useState("SFQRHQZ32cNfwjSpyxmkRc7ZvvoejDwL");
  const [locale, setLocale] = useState("fr");
  const [environment, setEnvironment] = useState(DEFAULT_ENV);
  const [brand, setBrand] = useState("ig-debug");
  const [theme, setTheme] = useState("ig-debug");
  const [invisible, setInvisible] = useState(true);

  const domain = getDomain(environment);
  return (
    <div>
      <h1>April Demo</h1>
      <EnvironmentSelector onChange={(env) => setEnvironment(env)} />
      <InvisibleRequest onChange={(invisible) => setInvisible(invisible)} />
      <div>
        <label style={{ marginRight: "10px" }}>Anonymous Embed Token:</label>
        <input
          type="text"
          value={token}
          onChange={(e) => setToken(e.target.value)}
        />
      </div>
      <div>
        <label style={{ marginRight: "10px" }}>Brand :</label>
        <input
          type="text"
          value={brand}
          onChange={(e) => setBrand(e.target.value)}
        />
      </div>
      <div>
        <label style={{ marginRight: "10px" }}>Theme:</label>
        <input
          type="text"
          value={theme}
          onChange={(e) => setTheme(e.target.value)}
        />
      </div>
      <div>
        <label style={{ marginRight: "10px" }}>Locale:</label>
        <select value={locale} onChange={(e) => setLocale(e.target.value)}>
          <option value="fr">FR</option>
          <option value="nl">NL</option>
        </select>
      </div>
      {token && (
        <div key={`${token}-${locale}`}>
          <EmbedContainer
            embedUrl={`${domain}?aet=${token}&brand=${brand}&theme=${theme}&locale=${locale}&invisible=${invisible}`}
            showCode={true}
            urlToShow={`${domain}?aet=${token}&brand=${brand}&theme=${theme}&locale=${locale}`}
          />
        </div>
      )}
    </div>
  );
};

export default CustomDemo;
